export default __webpack_public_path__ + "static/media/gallery16.9b4a15e9.webp";